import './App.css';
import { BrowserRouter, HashRouter } from "react-router-dom";
import AppFame from './Views/AppFrame';


export default function App(props) {
  return (
    // <BrowserRouter>
    //   <AppFame />
    // </BrowserRouter>
    <HashRouter>
      <AppFame />
      </HashRouter>
  )
}